import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-employer-value-banking-v2.component.scss';
var FormItemEmployerValueBankingV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemEmployerValueBankingV2, _super);
    function FormItemEmployerValueBankingV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemEmployerValueBankingV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-employer-value-banking__button');
        this.provinceSelect = this.form.querySelector('select[name=province]');
        //Privacy 
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemEmployerValueBankingV2.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        });
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemEmployerValueBankingV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemEmployerValueBankingV2.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var postData = '';
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += 'service-type=' + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += '&product=' + product.value;
        }
        var _email = this.form.querySelector('input[name=emailAddress]');
        if (_email) {
            postData += '&emailAddress=' + _email.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += '&email=' + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += '&recipient=' + recipient.value + ',' + _email.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += '&subject=' + subject.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += '&description=' + description.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += '&redirect=' + redirect.value;
        }
        var _firstName = this.form.querySelector('input[name=firstName]');
        if (_firstName) {
            postData += '&firstname=' + _firstName.value;
        }
        var _lastName = this.form.querySelector('input[name=lastName]');
        if (_lastName) {
            postData += '&surname=' + _lastName.value;
        }
        var _phoneNumber = this.form.querySelector('input[name=phoneNumber]');
        if (_phoneNumber) {
            postData += '&contactNo=' + _phoneNumber.value;
        }
        var _province = this.form.querySelector('select[name=province]');
        if (_province) {
            postData += '&province=' + _province.value;
        }
        var _cityTown = this.form.querySelector('input[name=cityTown]');
        if (_cityTown) {
            postData += '&cityTown=' + _cityTown.value;
        }
        var _isStandardBankCustomer = this.form.querySelector('select[name=isStandardBankCustomer]');
        if (_isStandardBankCustomer) {
            postData += '&existing-customer=' + _isStandardBankCustomer.value;
        }
        var _canContactCustomer = this.form.querySelector('select[name=canContactCustomer]');
        if (_canContactCustomer) {
            postData += '&canContactCustomer=' + _canContactCustomer.value;
        }
        var _interests = this.form.querySelector('textarea[name=interests]');
        if (_interests) {
            postData += '&interests=' + _interests.value;
        }
        // fields
        var popiaConsent = this.form.querySelector("input[name=popia-consent]");
        if (popiaConsent) {
            postData += '&dataPrivacyConsent=' + (popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO");
        }
        postData += '&dataSharingGroup=' + this.getDataConsentValue(this.form, 'data-sharing-group');
        postData += '&dataSharing3rdParty=' + this.getDataConsentValue(this.form, 'data-sharing-3rd-party');
        postData += '&dataSharingBoarders=' + this.getDataConsentValue(this.form, 'data-sharing-boarders');
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            //Always show success message / no response from server (sending email)
            analyticsService.dtmFormComplete('complete', response.code);
            loader.classList.remove('active');
            thankYou.classList.add('active');
            success.classList.add('active');
            error.classList.add('hidden');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemEmployerValueBankingV2;
}(Base));
export { FormItemEmployerValueBankingV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-employer-value-banking-v2/form-item-employer-value-banking-v2.component.ts
// module id = 1010
// module chunks = 0